async function getCart() {
  return fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
}

function isTeeItem(item) {
  const pt = (item.product_type || "").toLowerCase();
  const title = (item.product_title || "").toLowerCase();
  return pt.includes("t-shirt") || pt.includes("tshirt") || title.includes("t-shirt") || title.includes("tshirt");
}

function isDiscountedLine(item) {
  return typeof item.final_line_price === "number"
    && typeof item.original_line_price === "number"
    && item.final_line_price < item.original_line_price;
}

function moveBannerUnderLastItem(bannerEl) {
  const items = Array.from(document.querySelectorAll("cart-items .mini-cart__navigation > li"));
  if (!items.length) return;
  items[items.length - 1].insertAdjacentElement("afterend", bannerEl);
}

// packsUnlocked = floor(non-tee qty / 2)
// packsCompleted = number of DISCOUNTED tees (discount actually applied)
// packsRemaining = packsUnlocked - packsCompleted
function computePacks(cart) {
  let totalQty = 0;
  let discountedTeeQty = 0;

  for (const it of (cart.items || [])) {
    const q = it.quantity || 0;
    totalQty += q;

    if (isTeeItem(it) && isDiscountedLine(it)) {
      discountedTeeQty += q; // discounted tee = completed pack
    }
  }

  // discounted tees shouldn't count as "buy" items
  const buyQty = Math.max(0, totalQty - discountedTeeQty);

  const packsUnlocked = Math.floor(buyQty / 2);
  const packsCompleted = discountedTeeQty;

  return { totalQty, discountedTeeQty, packsUnlocked, packsCompleted };
}

async function updateBundleOfferBanner() {
  const el = ensureBannerElement();
  if (!el) return;

  const cart = await getCart();
if ((cart.item_count || 0) === 0) {
  el.hidden = true;
  return;
}
el.hidden = false;

  const { totalQty, discountedTeeQty, packsUnlocked, packsCompleted } = computePacks(cart);
const unclaimedPacks = Math.max(0, packsUnlocked - packsCompleted);

const claimed = packsCompleted;          // number of discounted tees

el.classList.toggle("claimed", claimed > 0);

const unclaimed = unclaimedPacks;        // unlocked packs not yet claimed

let line1 = "";
let line2 = "";

if (claimed > 0) {
  line1 = `✓ <strong>${claimed}</strong> pack${claimed === 1 ? "" : "s"} claimed (Free tee applied).`;
}

if (totalQty < 2) {
  line2 = `Add <strong>${2 - totalQty}</strong> more item${(2 - totalQty) === 1 ? "" : "s"} to unlock your FREE t-shirt.`;
} else if (unclaimed > 0) {
  line2 = `Pack #${claimed + 1} unlocked — add any <strong>T-shirt</strong> and is <strong>FREE</strong>.`;
} else if (claimed > 0) {
   // If we already claimed at least 1 pack, the "4th item" case should say 1 more item.
  const needed = (totalQty % 2 === 0) ? 1 : 2;
  line2 = `Add <strong>${needed}</strong> more item${needed === 1 ? "" : "s"} to unlock pack #${claimed + 1}.`;
} else {
  line2 = `Offer activated — add any <strong>T-shirt</strong> and is <strong>FREE</strong>.`;
}

el.innerHTML = `${line1 ? line1 + "<br>" : ""}${line2}`;
  moveBannerUnderLastItem(el);
}

// Run initially


// Re-run after quantity changes / remove clicks (your theme uses ajax; just refresh after interactions)
//

function observeMiniCart() {
  const root = document.querySelector(".mini-cart");
  if (!root) return;

  let t;
  const obs = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(updateBundleOfferBanner, 50);
  });

  obs.observe(root, { childList: true, subtree: true });
}

// Run initially + observe rerenders

function ensureBannerElement() {
  
  const el = document.getElementById("bundle-offer-banner");
  if (el) return el;

}

// Always call this inside updateBundleOfferBanner() BEFORE using the element
// Replace: const el = document.getElementById(...)
// With: const el = ensureBannerElement();

function hookCartRequests() {
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    const url = String(args[0] || "");
    if (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update") || url.includes("/cart/clear")) {
      scheduleUpdate();
    }
    return res;
  };
}

function watchMiniCartReplacement() {
  // Watch the whole document for mini-cart being replaced
  const obs = new MutationObserver(() => {
    // If mini-cart exists now (or got replaced), refresh banner
    if (document.querySelector(".mini-cart") || document.querySelector("cart-drawer") || document.querySelector("cart-items")) {
      setTimeout(updateBundleOfferBanner, 50);
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", () => {
  hookCartRequests();
  scheduleUpdate();
  startBannerAttentionLoop();
});

let t;
function scheduleUpdate() {
  clearTimeout(t);
  t = setTimeout(updateBundleOfferBanner, 120);
}

let bannerShakeInterval;

function startBannerAttentionLoop() {

  if (bannerShakeInterval) return;

  bannerShakeInterval = setInterval(() => {

    const el = document.getElementById("bundle-offer-banner");
    if (!el) return;

    el.classList.remove("shake");

    // restart animation
    void el.offsetWidth;

    el.classList.add("shake");

  }, 2500); // 2s idle + 0.5s shake
}